import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { OrderLifetimeRuleAction } from '@cbridge-packages/order-lifetime-rules';
import { RulesManagementAction } from '@cbridge-modules/rules-management-page';

export const onUpdateOrderLifetimeRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    OrderLifetimeRuleAction.update.done,
  ),
  mergeMap(() => {
    return [
      RulesManagementAction.endEditing(undefined),
    ];
  }),
);
